import { JetView } from 'webix-jet'; // Importing JetView from webix-jet library
import { profile, devConfig, countries, paymentSystem, cashDesks, agentList } from 'config/config'; // Importing configuration constants

/**
 * Class representing the FilterRequestsAgentView.
 * @extends JetView
 */
export default class FilterRequestsAgentView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The layout configuration for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section of the form
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for user
                            name: 'User',
                            type: 'Usuario',
                            label: "<span class='icon-user-secret'></span>" + _('Usuario'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Agente'), // Localized placeholder
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            // Upper section of the form
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including left section
                },
            ],
        };

        const buttons = {
            // Button section of the form
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'), // Localized button text
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Clear form values on click
                                $$('myForm').setValues($$('myForm').getCleanValues());
                                $$('Datepicker').setValue('');
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'), // Localized button text
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Trigger filter event on click
                                const filterdata = this.getRoot().getValues();
                                this.app.callEvent('detailsRequirements:filter', [filterdata]);
                            },
                        },
                    ],
                },
            ],
        };

        return {
            // Returning the complete form configuration
            view: 'form',
            id: 'myForm',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} form - The form instance.
     */
    init(form) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500) {
                // Hide element if screen width is small
                $$('grav').hide();
            }
        });
    }
}

// FILE DOCUMENTED
